import { useParams } from "@tanstack/react-router";
import { EmptyState } from "@sylviq/ui-react-web/components/ui/empty-state";
import { CultivationWorkspacePage } from "@/features/cultivation/CultivationWorkspacePage";
import type { CultivationPage } from "@/features/cultivation/cultivation-types";
import { ExtensionFrame } from "./ExtensionFrame";

const CULTIVATION_PAGES = new Set<CultivationPage>([
  "costing",
  "imports",
  "close",
  "history",
]);

export function ExtensionWorkspacePage() {
  const { publisher, key, page } = useParams({ strict: false }) as {
    publisher?: string;
    key?: string;
    page?: string;
  };

  if (!publisher || !key) {
    return <EmptyState title="Extension page not found" reason="The page address is incomplete." />;
  }

  if (
    publisher === "sylviq" &&
    key === "niche-cultivation-costing" &&
    page &&
    CULTIVATION_PAGES.has(page as CultivationPage)
  ) {
    return <CultivationWorkspacePage page={page as CultivationPage} />;
  }

  return <ExtensionFrame publisher={publisher} extensionKey={key} viewId={page} />;
}
